import { DependenciesPayload, Identity } from '@sxm-de/dev-kits/web-sdk/types';
import { MapClientSdkToWebSdk } from '@sxm-de/dev-kits/web-sdk/utils';

export async function getIdentity({
    clientSdk,
}: DependenciesPayload): Promise<Identity> {
    const mapClientSdkToWebSdk: MapClientSdkToWebSdk<
        Awaited<ReturnType<typeof clientSdk.user.identity>>,
        Identity
    > = (identity) => {
        return {
            ...identity,
            contact: {
                emailAddress: identity.contact?.emailAddress || '',
                phoneNumber: identity.contact?.phoneNumber || '',
            },
            handle: {
                emailAddress:
                    'emailAddress' in identity.handle
                        ? identity.handle.emailAddress
                        : undefined,
                username:
                    'username' in identity.handle
                        ? identity.handle.username
                        : undefined,
            },
            state: identity.state || 'ATLAS',
        };
    };
    const identity = mapClientSdkToWebSdk(await clientSdk.user.identity());
    return identity;
}
